import { render, staticRenderFns } from "./OpenAlertDialog.vue?vue&type=template&id=0029979a&scoped=true&"
import script from "./OpenAlertDialog.vue?vue&type=script&lang=js&"
export * from "./OpenAlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./OpenAlertDialog.vue?vue&type=style&index=0&id=0029979a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0029979a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAlert,VDialog})
